<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
    >
      <slot name="body">
          
    <div>
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12" >
              <form-select
                label="الموظف الجديد"
                v-model="form.ministry_user_id"
                :getOptionLabel="(x) => x.full_name"
                :reduce="(x) => x.id"
                id="gov"
                :ep="ep"
                ref="newEmployee"
                rules="required"
              />
            </b-col>
          </b-row>

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
// import store from "../pages/transactions/store";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => " إعادة إسناد ",
    },
    isHaveNote: {
      type: Boolean,
      default: () => true,
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["TransactionType"]),
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactionType"]),
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  
  mounted() {
    // this.fetchTransactionType()
    // this.$store.fetchTransactionType()
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    ep(){
      // return `v2/ministry/selects/get-suitable-ministry-users/1`;
      return this.form.transaction_id 
          ? "v2/ministry/selects/get-suitable-ministry-users/" + this.form.transaction_id
          : "v";
    }
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          this.init(this.intializeForm);
        });
    },
    ep(newVal) {
        this.$refs.newEmployee.refreshOptions(newVal);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    },
    
    onClickedAdd(){
      console.log(this.form)
      if(!this.form.hasOwnProperty('files') || Object.keys(this.form.files).length === 0 ){
    
        this.form.files =[{}]
      }
      else{
        
        // check if any form station => open without save Data
        let i=0
        if(this.form.files.length === 0)
        {
          this.form.files.push({})
        }
        
        else{
          for(let item of this.form.files)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.files.splice(i-1, 1) 
            }
        
        
          }
          this.form.files.push({})
        }

      

      }
    },
    onClickedDeleted(i){
      this.form.files.splice(i-1, 1) 

    }
  },
};
</script>
